import { selector } from 'recoil';
import { orderPayload } from './index';

export const addADGroup = selector({
    key: 'aws_av_addADGroup',
    get: ({ get }) => get(orderPayload).adGroupList,
    set: ({ set, get }, count) => {
        const currentADGroupList = get(orderPayload).adGroupList;
        let adGroupList = [null];
        adGroupList = [...currentADGroupList, ...Array(count.count).fill({ adGroupValue: null })];

        set(orderPayload, {
            ...get(orderPayload),
            adGroupList,
        });
    },
});

export const removeADGroup = selector({
    key: 'aws_av_removeADGroup',
    get: ({ get }) => get(orderPayload).adGroupList,
    set: ({ set, get }, adGroupToRemove) => {
        const currentADGroupList = get(orderPayload).adGroupList;
        const adGroupToRemoveIndex = currentADGroupList.findIndex((val) => val === adGroupToRemove);
        const adGroupList = [...currentADGroupList.slice(0, adGroupToRemoveIndex), ...currentADGroupList.slice(adGroupToRemoveIndex + 1)];
        set(orderPayload, {
            ...get(orderPayload),
            adGroupList,
        });
    },
});

export const updateADGroup = selector({
    key: 'aws_av_updateADGroup',
    get: ({ get }) => get(orderPayload).adGroupList,
    set: ({ set, get }, params) => {
        const currentADGroupList = get(orderPayload).adGroupList;
        if (params?.key === 'inputSelect') {
            const updatedADGroup = { ...currentADGroupList[params.index], adGroupValue: params.selectedValue.label };
            const adGroupList = [...currentADGroupList.slice(0, params?.index), updatedADGroup, ...currentADGroupList.slice(params?.index + 1)];
            set(orderPayload, { ...get(orderPayload), adGroupList });
        }
        if (params?.key === 'inputChange') {
            const updatedADGroup = { ...currentADGroupList[params.index], adGroupInputValue: params.selectedValue };
            const adGroupList = [...currentADGroupList.slice(0, params?.index), updatedADGroup, ...currentADGroupList.slice(params?.index + 1)];
            set(orderPayload, { ...get(orderPayload), adGroupList });
        }
    },
});

export const addReaderADGroup = selector({
    key: 'aws_av_addReaderADGroup',
    get: ({ get }) => get(orderPayload).nonPrivilegedADGroupList,
    set: ({ set, get }, count) => {
        const currentReaderADGroupList = get(orderPayload).nonPrivilegedADGroupList;
        let nonPrivilegedADGroupList = [null];
        nonPrivilegedADGroupList = [...currentReaderADGroupList, ...Array(count.count).fill({ readerValue: null })];

        set(orderPayload, {
            ...get(orderPayload),
            nonPrivilegedADGroupList,
        });
    },
});

export const removeReaderADGroup = selector({
    key: 'aws_av_removeReaderADGroup',
    get: ({ get }) => get(orderPayload).nonPrivilegedADGroupList,
    set: ({ set, get }, adGroupToRemove) => {
        const currentReaderADGroupList = get(orderPayload).nonPrivilegedADGroupList;
        const readerADGroupToRemoveIndex = currentReaderADGroupList.findIndex((val) => val === adGroupToRemove);
        const nonPrivilegedADGroupList = [
            ...currentReaderADGroupList.slice(0, readerADGroupToRemoveIndex),
            ...currentReaderADGroupList.slice(readerADGroupToRemoveIndex + 1),
        ];
        set(orderPayload, {
            ...get(orderPayload),
            nonPrivilegedADGroupList,
        });
    },
});

export const updateReaderADGroup = selector({
    key: 'aws_av_updateReaderADGroup',
    get: ({ get }) => get(orderPayload).nonPrivilegedADGroupList,
    set: ({ set, get }, params) => {
        const currentReaderADGroupList = get(orderPayload).nonPrivilegedADGroupList;
        if (params?.key === 'inputSelect') {
            const updatedReaderADGroup = { ...currentReaderADGroupList[params.index], readerValue: params.selectedValue.label };
            const nonPrivilegedADGroupList = [
                ...currentReaderADGroupList.slice(0, params?.index),
                updatedReaderADGroup,
                ...currentReaderADGroupList.slice(params?.index + 1),
            ];
            set(orderPayload, { ...get(orderPayload), nonPrivilegedADGroupList });
        }
        if (params?.key === 'inputChange') {
            const updatedReaderADGroup = { ...currentReaderADGroupList[params.index], readerInputValue: params.selectedValue };
            const nonPrivilegedADGroupList = [
                ...currentReaderADGroupList.slice(0, params?.index),
                updatedReaderADGroup,
                ...currentReaderADGroupList.slice(params?.index + 1),
            ];
            set(orderPayload, { ...get(orderPayload), nonPrivilegedADGroupList });
        }
    },
});

export const addContributorADGroup = selector({
    key: 'aws_av_addContributorADGroup',
    get: ({ get }) => get(orderPayload).privilegedADGroupList,
    set: ({ set, get }, count) => {
        const currentContributorADGroupList = get(orderPayload).privilegedADGroupList;
        let privilegedADGroupList = [null];
        privilegedADGroupList = [...currentContributorADGroupList, ...Array(count.count).fill({ contributorValue: null })];

        set(orderPayload, {
            ...get(orderPayload),
            privilegedADGroupList,
        });
    },
});

export const removeContributorADGroup = selector({
    key: 'aws_av_removeContributorADGroup',
    get: ({ get }) => get(orderPayload).privilegedADGroupList,
    set: ({ set, get }, adGroupToRemove) => {
        const currentContributorADGroupList = get(orderPayload).privilegedADGroupList;
        const contributorADGroupToRemoveIndex = currentContributorADGroupList.findIndex((val) => val === adGroupToRemove);
        const privilegedADGroupList = [
            ...currentContributorADGroupList.slice(0, contributorADGroupToRemoveIndex),
            ...currentContributorADGroupList.slice(contributorADGroupToRemoveIndex + 1),
        ];
        set(orderPayload, {
            ...get(orderPayload),
            privilegedADGroupList,
        });
    },
});

export const updateContributorADGroup = selector({
    key: 'aws_av_updateContributorADGroup',
    get: ({ get }) => get(orderPayload).privilegedADGroupList,
    set: ({ set, get }, params) => {
        const currentContributorADGroupList = get(orderPayload).privilegedADGroupList;
        if (params?.key === 'inputSelect') {
            const updatedContributorADGroup = { ...currentContributorADGroupList[params.index], contributorValue: params.selectedValue.label };
            const privilegedADGroupList = [
                ...currentContributorADGroupList.slice(0, params?.index),
                updatedContributorADGroup,
                ...currentContributorADGroupList.slice(params?.index + 1),
            ];
            set(orderPayload, { ...get(orderPayload), privilegedADGroupList });
        }
        if (params?.key === 'inputChange') {
            const updatedContributorADGroup = { ...currentContributorADGroupList[params.index], contributorInputValue: params.selectedValue };
            const privilegedADGroupList = [
                ...currentContributorADGroupList.slice(0, params?.index),
                updatedContributorADGroup,
                ...currentContributorADGroupList.slice(params?.index + 1),
            ];
            set(orderPayload, { ...get(orderPayload), privilegedADGroupList });
        }
    },
});
